import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AppLayout } from './components/layout/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { InviteAcceptPage } from './pages/InviteAcceptPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { SuperAdminPage } from './pages/SuperAdminPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { DashboardPage } from './pages/DashboardPage';
import { BookingPage } from './pages/BookingPage';
import { ApprovalsPage } from './pages/ApprovalsPage';
import { BudgetPage } from './pages/BudgetPage';
import { ReportsPage } from './pages/ReportsPage';
import { TravelersPage } from './pages/TravelersPage';
import { TripsPage } from './pages/TripsPage';
import { SettingsPage } from './pages/SettingsPage';
import { ExpensesPage } from './pages/ExpensesPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { TripDetailPage } from './pages/TripDetailPage';
import { DemoFlowPage } from './pages/DemoFlowPage';
import { OperationsQueuePage } from './pages/OperationsQueuePage';
import { AuditLogsPage } from './pages/AuditLogsPage';
import { SupportPage } from './pages/SupportPage';
import { EventsPage } from './pages/EventsPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { IntegrationsPage } from './pages/IntegrationsPage';
import { RefundPoliciesPage } from './pages/RefundPoliciesPage';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState<string | null>(null);
  const [isOnboarded, setIsOnboarded] = useState(true);
  const handleLogin = (role: string) => {
    setUserRole(role);
    setIsAuthenticated(true);
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserRole(null);
  };
  return <AppProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          {/* Public Routes */}
          <Route path="/login" element={!isAuthenticated ? <LoginPage onLogin={handleLogin} data-id="element-4" /> : <Navigate to="/" replace data-id="element-5" />} data-id="element-3" />
          <Route path="/register" element={<RegisterPage data-id="element-7" />} data-id="element-6" />
          <Route path="/invite" element={<InviteAcceptPage data-id="element-9" />} data-id="element-8" />

          {/* Protected Routes */}
          <Route path="/*" element={isAuthenticated ? <AppLayout onLogout={handleLogout} userRole={userRole} data-id="element-11">
                  <Routes data-id="element-12">
                    {/* Home page - role-specific redirect */}
                    {userRole === 'super_admin' && <Route path="/" element={<Navigate to="/super-admin" replace data-id="element-14" />} data-id="element-13" />}
                    {userRole !== 'super_admin' && <Route path="/" element={<DashboardPage data-id="element-16" />} data-id="element-15" />}

                    {/* All page routes available to all authenticated roles */}
                    <Route path="/demo" element={<DemoFlowPage data-id="element-18" />} data-id="element-17" />
                    <Route path="/booking" element={<BookingPage data-id="element-20" />} data-id="element-19" />
                    <Route path="/trips" element={<TripsPage data-id="element-22" />} data-id="element-21" />
                    <Route path="/trips/:id" element={<TripDetailPage data-id="element-24" />} data-id="element-23" />
                    <Route path="/approvals" element={<ApprovalsPage data-id="element-26" />} data-id="element-25" />
                    <Route path="/budget" element={<BudgetPage data-id="element-28" />} data-id="element-27" />
                    <Route path="/expenses" element={<ExpensesPage data-id="element-30" />} data-id="element-29" />
                    <Route path="/reports" element={<ReportsPage data-id="element-32" />} data-id="element-31" />
                    <Route path="/travelers" element={<TravelersPage data-id="element-34" />} data-id="element-33" />
                    <Route path="/settings" element={<SettingsPage data-id="element-36" />} data-id="element-35" />
                    <Route path="/operations" element={<OperationsQueuePage data-id="element-38" />} data-id="element-37" />
                    <Route path="/audit-logs" element={<AuditLogsPage data-id="element-40" />} data-id="element-39" />
                    <Route path="/payments" element={<PaymentsPage data-id="element-42" />} data-id="element-41" />
                    <Route path="/integrations" element={<IntegrationsPage data-id="element-44" />} data-id="element-43" />
                    <Route path="/refund-policies" element={<RefundPoliciesPage data-id="element-46" />} data-id="element-45" />
                    <Route path="/admin/users" element={<AdminUsersPage data-id="element-48" />} data-id="element-47" />
                    <Route path="/notifications" element={<NotificationsPage data-id="element-50" />} data-id="element-49" />
                    <Route path="/events" element={<EventsPage data-id="element-52" />} data-id="element-51" />
                    <Route path="/support" element={<SupportPage data-id="element-54" />} data-id="element-53" />

                    {/* Super Admin routes */}
                    <Route path="/super-admin" element={<SuperAdminPage data-id="element-56" />} data-id="element-55" />
                    <Route path="/super-admin/tenants" element={<SuperAdminPage data-id="element-58" />} data-id="element-57" />
                    <Route path="/super-admin/settings" element={<SuperAdminPage data-id="element-60" />} data-id="element-59" />
                    <Route path="/super-admin/analytics" element={<SuperAdminPage data-id="element-62" />} data-id="element-61" />

                    {/* Onboarding */}
                    <Route path="/onboarding" element={<OnboardingPage data-id="element-64" />} data-id="element-63" />

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/" replace data-id="element-66" />} data-id="element-65" />
                  </Routes>
                </AppLayout> : <Navigate to="/login" replace data-id="element-67" />} data-id="element-10" />
        </Routes>
      </Router>
    </AppProvider>;
}